<template>
  <v-dialog
    v-model="dislogAddressVisible"
    fullscreen
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card style="position: relative">
      <button
        @click="closeDialog"
        style="
          position: absolute;
          width: 26px;
          height: 26px;
          top: 25px;
          left: 20px;
        "
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
          <path
            style="fill: #232326"
            d="M24 12.001H2.914l5.294-5.295-.707-.707L1 12.501l6.5 6.5.707-.707-5.293-5.293H24v-1z"
            data-name="Left"
          />
        </svg>
      </button>
      <h2 class="text-center pt-5 pb-2">{{ $t("addressSendReward") }}</h2>
      <v-divider style="border-color: rgb(0 0 0 / 20%)"></v-divider>
      <!-- Add new address -->
      <div
        @click="openAddAddress(false, -1)"
        class="d-flex justify-center align-center py-3 font-weight-bold"
        :style="{ color: site.color }"
        style="box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1)"
      >
        <div style="width: 18px; height: 18px" class="mr-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            :style="{ fill: site.color }"
          >
            <g data-name="51.Add">
              <path
                d="M12 24a12 12 0 1 1 12-12 12.013 12.013 0 0 1-12 12zm0-22a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2z"
              />
              <path d="M11 6h2v12h-2z" />
              <path d="M6 11h12v2H6z" />
            </g>
          </svg>
        </div>
        {{ $t("addressAdd") }}
      </div>

      <!-- Card -->
      <section
        class="d-flex flex-column align-center pt-3"
        style="overflow-y: auto; max-height: 75vh"
      >
        <div
          @click="setChooseAddress(index)"
          v-for="(item, index) in addressData"
          :key="item.id"
          class="mx-3 mb-2"
          style="max-width: 600px; width: 90vw"
        >
          <div
            class="pa-3 mb-2"
            style="border-radius: 8px; position: relative"
            :style="{
              border: chooseAddress === index ? '1px solid ' + site.color : '',
              backgroundColor:
                chooseAddress === index
                  ? 'rgba(' + hexToRgb(site.color) + ', 0.15)'
                  : '',
              transitionDuration: '200ms',
              transitionProperty: 'background-color, border-color',
              transitionTimingFunction: 'ease',
            }"
          >
            <div
              class="d-flex font-weight-medium"
              :style="{
                width: item.is_default ? '68%' : '90%',
              }"
            >
              <h3 class="description-label" style="">
                {{ item.name_address }}
              </h3>
            </div>
            <p class="text-subtitle-2">
              {{ item.name }} {{ item.surname }}
              <span class="" style="color: grey">| {{ item.mobile }}</span>
            </p>
            <p class="text-subtitle-2" style="color: grey">
              {{ item.address }}
            </p>

            <p
              class="font-weight-bold"
              :style="{ color: site.color }"
              @click="openAddAddress(true, index)"
              style="
                position: absolute;
                font-size: 0.85rem;
                top: 12px;
                right: 13px;
              "
            >
              {{ $t("edit") }}
            </p>
            <p
              class="font-weight-bold pa-1 px-2 rounded-lg"
              v-if="item.is_default"
              style="
                position: absolute;
                font-size: 0.85rem;
                top: 8px;
                right: 50px;
                background-color: #d9d9d9;
              "
            >
              {{ $t("defaultValue") }}
            </p>
          </div>
          <v-divider style="border-color: rgb(0 0 0 / 20%)"></v-divider>
          <div
            v-if="index === addressData.length - 1"
            style="height: 50px"
          ></div>
        </div>
      </section>

      <section
        class="d-flex justify-center py-5"
        style="
          background-color: white;
          position: absolute;
          bottom: 0px;
          width: 100%;
          box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1);
          z-index: 20;
        "
      >
        <v-btn
          @click="selectedAddress"
          :color="site.color"
          class="rounded-lg font-weight-bold"
          style="width: 75%; color: white; height: 40px; max-width: 600px"
        >
          {{ $t("textSelect") }}
        </v-btn>
      </section>
    </v-card>

    <DialogAddAddress
      :dialogAddAddressVisible="dialogAddAddressVisible"
      @updateResidence="handleResidenceUpdate"
      @close="dialogAddAddressVisible = false"
    />
  </v-dialog>
</template>

<script>
import Axios from "@/config/customer-service";
import DialogAddAddress from "./dialogAddAddress.vue";
export default {
  name: "DialogAddressRedeemFinal",
  props: ["dislogAddressVisible", "site"],
  components: {
    DialogAddAddress,
  },
  data() {
    return {
      chooseAddress: null,
      addressData: [],
      dialogAddAddressVisible: false,
      canEdit: true,
    };
  },
  created() {
    this.fetchAddress();
  },

  methods: {
    selectedAddress() {
      this.$emit("selectedAddress", this.addressData[this.chooseAddress]);
      this.$emit("close");
    },
    fetchAddress() {
      Axios.get("address/list")
        .then((res) => {
          if (res.data.status == "success") {
            this.addressData = res.data.data.data || [];
            if (this.addressData.length > 0) {
              const isDefault = this.addressData.findIndex(
                (data) => data.is_default === true
              );
              if (isDefault !== -1) {
                const defaultAddress = this.addressData.splice(isDefault, 1)[0];
                this.addressData.unshift(defaultAddress);
              }
              this.chooseAddress = 0;
              this.canEdit = res.data.data.can_edit;

              this.$emit(
                "selectedAddress",
                this.addressData[this.chooseAddress]
              );
            } else {
              this.chooseAddress = null;
              this.$emit("selectedAddress", null);
            }
          } else {
            console.error("API returned error status");
          }
        })
        .catch((err) => {
          console.error("Error fetching address:", err);
          this.$emit("selectedAddress", null);
        });
    },
    handleResidenceUpdate(newResidence, isEdit) {
      if (isEdit) {
        Axios.put("address/update", newResidence, {
          params: {
            addressId: newResidence.id,
          },
        }).then(() => {
          this.fetchAddress();
        });
      } else {
        Axios.post("address/create", newResidence).then(() => {
          this.fetchAddress();
        });
      }
    },
    setChooseAddress(selectedIndex) {
      this.chooseAddress = selectedIndex;
    },
    closeDialog() {
      this.$emit("close");
    },
    hexToRgb(hex) {
      let r = 0,
        g = 0,
        b = 0;

      // 3 digits
      if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
      }
      // 6 digits
      else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
      }

      return r + "," + g + "," + b;
    },
    openAddAddress(isEdit, selected) {
      if (isEdit) {
        this.$store.commit("address/SET_RESIDENCE", {
          target: this.addressData[selected],
          editAddress: true,
        });
      } else {
        this.$store.commit("address/SET_RESIDENCE", {
          target: {},
          editAddress: false,
        });
      }

      this.dialogAddAddressVisible = true;
    },
  },
};
</script>

<style>
.description-label {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.description-label-2 {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
</style>